module.exports = __webpack_public_path__ + "static/media/brother-printers.feee23f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brother-printers.png
// module id = 362
// module chunks = 3